export interface MongoApiRequestBody {
  query: string;
  parameters: MongoApiQueryParameters;
  pagination?: MongoApiPaginationRequest;
  sorting?: SortingRequest;
}

export interface MongoApiPaginationRequest {
  limit: number;
  offset: number;
}

export interface MongoApiQueryParameters {
  [key: string]: any;
}

export interface MongoApiQueryFunctionResponse {
  data: any;
  returnedDocumentsSize: number;
  totalDocumentsSize: number;
  hasMore: boolean;
  limitReached?: boolean;
}

export interface Account {
  account_id: number;
  company_contact: {
    company: string;
  };
  company: Company[];
  status: "inactive" | "active";
  condition: "active" | "inactive" | "onboarding" | "demo";
  purged: boolean;
  engaged_as_of_date: Date | null;
  is_customer: boolean;
  paying: boolean;
  account_type: string;
  engaged: number;
  has_logged_in: number;
  has_jobs_that_did_work: number;
  proxy: boolean;
  connection_count: number;
  origin_system: string | null;
  origin_id: number | null;
  os_proxy_id: string;
  create_date: Date;
  last_update: Date;
  purge_tag: string;
  purge_capture_date: Date;
  purge_date: Date;
  reporting: string;
  can_create_managed_accounts: boolean;
  integration_type: string;
  detected_integrations: string;
  sla_locale: string;
  sla_timezone: string;
  users: User[];
}

export interface Item {
  item_id: number;
  product_id: number;
  sku: string;
  title: string;
  quantity_available: number;
  stock_on_hand: number;
}

export interface Warehouse {
  supplier_id: number;
  warehouse_id: string;
  code: string;
  status: string;
  name: string;
  last_update: Date;
  items: Item[];
  totalQuantity: number;
}

export interface User {
  user_id: number;
  full_name?: string;
  first_name?: string;
  last_name?: string;
  last_login: Date;
  email: string;
  username: string;
  role: string;
  status: "active" | "inactive";
}

export interface Company {
  name: string;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  contact_address1: string;
  contact_address2?: string;
  contact_city: string;
  contact_region: string;
  contact_postal: string;
  contact_country: string;
  website: string;
  logo_url: string;
  categories: string[];
  clout: string;
}

export interface AccountSearchRequestBody {
  keyword: string;
  pagination: MongoApiPaginationRequest;
  sorting?: SortingRequest;
  environment: string;
}

export interface AccountDetailsRequestBody {
  accountIds: number[];
  environment: string;
}

export interface UsersByAccountIdRequestBody {
  accountId: number;
  environment: string;
}

export interface WarehouseByAccountIdRequestBody {
  accountId: number;
  environment: string;
}

export interface AccountSearchResponseBody
  extends MongoApiQueryFunctionResponse {
  data: {
    accounts: Account[];
    accountIds: number[];
  };
  environment: string;
  keyword: string;
}

export interface AccountDetailsResponseBody
  extends MongoApiQueryFunctionResponse {
  data: {
    accounts: Account[];
  };
  environment: string;
}

export interface SortingRequest {
  key: string;
  direction: SortingDirection;
}

export enum SortingDirection {
  ASC = "asc",
  DSC = "dsc",
}

export interface ShippingLabelTroubleshootRequestBody {
  orderId?: string;
  supplierId?: string;
  poNumber?: string;
  environment: string;
}

export interface AuditLogEntry {
  request: Record<string, any>;
  error?: string;
  endState: "success" | "failed";
  timestamp: string;
  orderId: string;
  supplierId: string;
  poNumber?: string;
}
